import { useContext } from 'react';
import { ConfigContext } from '../../../../Contexts/ConfigContext';
import CheckBoxInput from '../../../../Components/CheckBoxInput';
import PageHeading from '../../../../Components/PageHeading';

//mui imports====
import useCommonStyles from '../../../../commonStyles';
import { Grid, Paper } from '@mui/material';
//===============

const DisableApLogoConfig = ({ keyData, featureDescription }) => {
	const commonStyleClasses = useCommonStyles();
	const { rawConfig, updateRawConfig } = useContext(ConfigContext); //rawConfig from ConfigContext
	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="Disable Ap Logo"
				headingPath={['Dashboard', 'Framerate', 'Features Data', 'Disable Ap Logo']}
				description="Switch on enabled to disable the Ap Logo"
				showInfoButton={true}
				infoMessage={featureDescription}
			/>
			<Grid container spacing={0} style={{ margin: '4rem 0 0 5rem', width: '90%' }}>
				<Grid item xs={3}>
					<CheckBoxInput
						keyData={keyData}
						label="enabled"
						disabled={false}
						defaultChecked={false}
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
			</Grid>
		</Paper>
	);
};
export default DisableApLogoConfig;
